import Bowser from "bowser";

const bowser = Bowser.parse(window.navigator.userAgent);
const supported: string[] = [
  "Chrome",
  "Chromium",
  "Firefox",
  "Microsoft Edge",
  "Safari",
  "Electron",
];
export const browserName = bowser.browser.name || "";
export const isSupported = supported.includes(browserName);
